import React from 'react';

const TONE_MAP = {
  enabled: 'success', active: 'success', succeeded: 'success', completed: 'success',
  approved: 'success', connected: 'success', reviewed: 'success', trusted: 'success',
  yes: 'success', true: 'success', granted: 'success',
  running: 'info', started: 'info', unstarted: 'info', live: 'info',
  pending: 'warn', queued: 'warn', draft: 'warn', unreviewed: 'warn', backlog: 'warn',
  awaiting_approval: 'warn',
  disabled: 'muted', disconnected: 'muted', no: 'muted', false: 'muted', unknown: 'muted',
  failed: 'danger', rejected: 'danger', error: 'danger', quarantined: 'danger',
  untrusted: 'danger', cancelled: 'danger', denied: 'danger',
};

export function toneFor(value) {
  const key = String(value ?? '').toLowerCase();
  return TONE_MAP[key] || 'muted';
}

const RISK_TONE = ['success', 'info', 'warn', 'danger'];

export function riskToneFor(tier) {
  const n = Number(tier);
  if (!Number.isFinite(n)) return 'muted';
  return RISK_TONE[Math.min(Math.max(n, 0), 3)];
}

export function Badge({ value, tone, children }) {
  const resolvedTone = tone || toneFor(value);
  return <span className={`badge badge--${resolvedTone}`}>{children ?? String(value ?? '—')}</span>;
}

export default Badge;
